import { createSlice } from "@reduxjs/toolkit";
import {
  onGetProductCategoryList,
  onAddProductCategory,
  onUpdateProductCategory,
  onDeleteProductCategory,
  onGetCampaignList,
  onGetPromoList,
  onAddCampaign,
  onUpdateCampaign,
  onDeleteCampaign,
  onAddPromo,
  onUpdatePromo,
  onDeletePromo,
} from './thunk';

export const initialState = {
  productCategoryList: [],
  campaignList: [],
  promoList: [],
  errors: {}
};

const MaintenancesSlice = createSlice({
  name: 'Maintenances',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(onGetProductCategoryList.fulfilled, (state: any, action: any) => {
      state.productCategoryList = action.payload;
    });
    builder.addCase(onGetProductCategoryList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddProductCategory.fulfilled, (state: any, action: any) => {
      state.productCategoryList.unshift(action.payload);
    });
    builder.addCase(onAddProductCategory.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateProductCategory.fulfilled, (state: any, action: any) => {
      state.productCategoryList = state.productCategoryList.map((list: any) =>
        list.productCategoryId === action.payload.productCategoryId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateProductCategory.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteProductCategory.fulfilled, (state: any, action: any) => {
      state.productCategoryList = state.productCategoryList.filter(
        (productCategory: any) => productCategory.productCategoryId.toString() !== action.payload.productCategoryId.toString()
      );
    });
    builder.addCase(onDeleteProductCategory.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // Campaign
    builder.addCase(onGetCampaignList.fulfilled, (state: any, action: any) => {
      state.campaignList = action.payload;
    });
    builder.addCase(onGetCampaignList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddCampaign.fulfilled, (state: any, action: any) => {
      state.campaignList.unshift(action.payload);
    });
    builder.addCase(onAddCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdateCampaign.fulfilled, (state: any, action: any) => {
      state.campaignList = state.campaignList.map((list: any) =>
        list.campaignId === action.payload.campaignId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdateCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeleteCampaign.fulfilled, (state: any, action: any) => {
      state.campaignList = state.campaignList.filter(
        (campaign: any) => campaign.campaignId.toString() !== action.payload.campaignId.toString()
      );
    });
    builder.addCase(onDeleteCampaign.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });

    // Promo
    builder.addCase(onGetPromoList.fulfilled, (state: any, action: any) => {
      state.promoList = action.payload;
    });
    builder.addCase(onGetPromoList.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onAddPromo.fulfilled, (state: any, action: any) => {
      state.promoList.unshift(action.payload);
    });
    builder.addCase(onAddPromo.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onUpdatePromo.fulfilled, (state: any, action: any) => {
      state.promoList = state.promoList.map((list: any) =>
        list.promoId === action.payload.promoId
          ? { ...list, ...action.payload }
          : list
      );
    });
    builder.addCase(onUpdatePromo.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
    builder.addCase(onDeletePromo.fulfilled, (state: any, action: any) => {
      state.promoList = state.promoList.filter(
        (promo: any) => promo.promoId.toString() !== action.payload.promoId.toString()
      );
    });
    builder.addCase(onDeletePromo.rejected, (state: any, action: any) => {
      state.error = action.payload.error || null;
    });
  }
});

export default MaintenancesSlice.reducer;